module.exports = __webpack_public_path__ + "img/2.51c3272d.jpg";